import { getImageSRC } from "@/functions/assets";
import { getTimeFromNow } from "@/functions/time";
import type { CurrentTicketType } from "@/modules/ticket/ticketDetail/currentTicket/currentTicketSlice";
import { Attachment } from "@/modules/ticket/ticketDetail/messages/messageListOperations";

interface CardHeaderImage {
  preview: string;
  src: string;
}

interface CardHeader {
  title?: string;
  subheader: string;
  preview?: string;
  src?: string;
}

export const getCardHeader = (
  item: CurrentTicketType,
  attachments?: Attachment[],
): CardHeader => {
  const firstImage = getFirstImage(attachments);
  return {
    title: item.subject,
    ...(firstImage && { ...firstImage }),
    subheader: item.anonymous
      ? getTimeFromNow(item.createdAt!)
      : `${item.author} ${getTimeFromNow(item.createdAt!)}`,
  };
};

const getFirstImage = (
  attachments?: Attachment[],
): CardHeaderImage | undefined => {
  if (attachments && attachments[0]) {
    const file = attachments[0];
    return {
      preview: file.previewFilename
        ? `${getImageSRC(file.previewFilename)}&scalePercent=100`
        : getImageSRC(file.filename),
      src: getImageSRC(file.filename),
    };
  }
  return undefined;
};
